import React from 'react';
import ReactDOM from 'react-dom/client';
import "./styles/index.scss";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register the PWA service worker (production only). A working fetch handler is
// what lets Chrome fire `beforeinstallprompt` so the in-app install popup can
// appear — and it gives the dashboard an offline shell.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const scope = process.env.PUBLIC_URL || "/";
    navigator.serviceWorker
      .register(`${scope}/sw.js`)
      .catch((error) => console.warn("Service worker registration failed:", error));
  });
}
